import { Link } from "react-router-dom";

export const leases = [
  {
    key: "1",
    name: "John Smith",
    age: 32,
    address: "Lorem ipsum dolor sit amet,",
    tags: ["Lorem ipsum1"],
  },
  {
    key: "2",
    name: "Jim Green",
    age: 42,
    address: "Lorem ipsum dolor sit amet,",
    tags: ["Lorem ipsum2"],
  },
  {
    key: "3",
    name: "Joe Black",
    age: 32,
    address: "Lorem ipsum dolor sit amet,",
    tags: ["Lorem ipsum3"],
  },
];
export const leasesbtn = [
  {
    key: "1",
    label: <Link to="?filter_type=all">All</Link>,
    children: `There are currently no lease documents.`,
  },
  {
    key: "2",
    label: (
      <Link to="?filter_type=ReadytoCountersign">Ready to Countersign</Link>
    ),
    children: `There are currently no lease documents of type Ready to Countersign.`,
  },
  {
    key: "3",
    label: <Link to="?filter_type=OutforSigning">Out for Signing</Link>,
    children: `There are currently no lease documents of type Out for Signing.`,
  },
  {
    key: "4",
    label: <Link to="?filter_type=Printed">Printed</Link>,
    children: `There are currently no lease documents of type Printed.`,
  },
];

export const LeasTemplates = [
  {
    id: 1,
    title: "New Move in Lease Template",
  },
  {
    id: 2,
    title: "New Move in Lease Template Copy (TEST)",
  },
  {
    id: 3,
    title: "Renewal Lease Template",
  },
  {
    id: 4,
    title: "Sample Lease Template",
  },
];

export const addendumTemplates = [
  {
    id: 1,
    title: "2209 1/2 NE 16 Terr.",
  },
  {
    id: 2,
    title: "6119 NW 48th",
  },
  {
    id: 3,
    title: "6119 NW 48th Driveway note",
  },
  {
    id: 4,
    title: "6119 NW 48th Security deposit",
  },
];

export const sendLeaseAddendumOptions = [
  "2020 1/2 NE 16 Terr",
  "2020 1/2 NE 16 Terr",
  "2020 1/2 NE 16 Terr",
  "2020 1/2 NE 16 Terr",
  "2020 1/2 NE 16 Terr",
];
export const attachments = [
  {
    id: 1,
    title: "fw9__1_.pdf",
  },
  {
    id: 2,
    title: "Landlord_Tenant_Info_Pamphlet__11-2014___1_.pdf",
  },
];

export const pdfTemplates = [
  {
    id: 1,
    templateName: "Test",
    createdOn: "01/02,2023",
    templateType: "Resident Form",
  },
];
